import { render, staticRenderFns } from "./MediaAccreditationEventSettingsForm.vue?vue&type=template&id=c1261678&scoped=true"
import script from "./MediaAccreditationEventSettingsForm.vue?vue&type=script&lang=js"
export * from "./MediaAccreditationEventSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1261678",
  null
  
)

export default component.exports